import { isParseObject, useFeedback, useTranslation } from "@opendash/core";
import { Source } from "@opendash/core/dist/types-generated";
import { Button, Checkbox, DatePicker, Divider, Form, Input } from "antd";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import Parse from "parse";
import React from "react";
import { Message } from "../../../js/parsegenerated";
import { Ticket } from "../../../js/parsegenerated/Ticket";
import { MessageData } from "../types/MessageData";

export const ArticleCollapsable = observer(
  (props: {
    showdivider: boolean;
    referencedObject: Ticket | Source | null | undefined;
    shownewmessage: true;
    onOkUpdate: Function;
    dateField?: boolean;
    showAsTodo?: boolean;
    lockTodo?: boolean;
    dividerLabel?: string;
  }) => {
    const t = useTranslation();
    const { message } = useFeedback();
    const [form] = Form.useForm<{
      newtitle: string;
      newbody: string;
      date: dayjs.Dayjs;
      asTodo?: boolean;
    }>();
    const { TextArea } = Input;

    const onClick = () => {
      form.validateFields().then(
        async (value) => {
          try {
            const current = new Date();
            const newMessage: Message = new Message();
            const savedmessage = await newMessage.save({
              user: Parse.User.current(),
              tenant: Parse.User.current().get("tenant"),
              title: value.newtitle
                ? value.newtitle
                : "maintenance:article.create.default_subject." +
                  (value.asTodo ? "todo" : "userinput"),
              classname:
                props.referencedObject !== undefined &&
                isParseObject(props.referencedObject, Ticket.className)
                  ? Ticket.className
                  : Source.className,
              referencedObjectId: props.referencedObject?.id,
              displayAt: value.date
                ? new Date(value.date.toISOString())
                : current,
              data: {
                type: value.asTodo ? "todo" : "userinput",
              } as MessageData,
              content: value.newbody,
            });

            message.success(t("maintenance:global.messages.save.success"), 10);
            form.resetFields();
            props.onOkUpdate();
          } catch (error) {
            message.error(t("maintenance:global.messages.save.error"), 10);
          }
        },
        (formerror: any): void => {
          formerror.errorFields.forEach((error: any) => {
            error.errors.forEach((singleerror: any) => {
              message.error(singleerror, 5);
            });
          });
        }
      );
    };

    return (
      <>
        {props.showdivider && (
          <Divider orientation="left" style={{ marginTop: 150 }}>
            {props.dividerLabel ||
              t("maintenance:article.collapsable.headline")}
          </Divider>
        )}
        {props.shownewmessage && (
          <>
            <Form
              form={form}
              autoComplete="off"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 14 }}
              layout="horizontal"
            >
              <Form.Item name="newtitle" key="newtitle" label="Titel">
                <Input />
              </Form.Item>
              <Form.Item
                name="newbody"
                key="newbody"
                label="Nachricht"
                rules={[
                  {
                    required: true,
                    message: t(
                      "maintenance:article.collapsable.form.rules.required"
                    ),
                  },
                ]}
              >
                <TextArea rows={4} />
              </Form.Item>

              {props.showAsTodo && (
                <Form.Item
                  name="asTodo"
                  valuePropName="checked"
                  label={t("maintenance:article.collapsable.form.asTodo.label")}
                  initialValue={props.lockTodo}
                  hidden={props.lockTodo}
                >
                  <Checkbox />
                </Form.Item>
              )}
              {props.dateField && (
                <Form.Item
                  help={t("maintenance:article.collapsable.form.date.help")}
                  name="date"
                  label={t("maintenance:article.collapsable.form.date.label")}
                >
                  <DatePicker style={{ width: "100%" }} showTime />
                </Form.Item>
              )}
            </Form>
            <Button type="primary" onClick={onClick}>
              {t("maintenance:global.button.save_label")}
            </Button>
          </>
        )}
      </>
    );
  }
);
